

import React, { useState, useEffect, useRef } from 'react';
import { useDataContext } from '../../contexts/DataContext';
import videojs from 'video.js';
// import { toDateString } from '../../cameraHelpers.js';
import "video.js/dist/video-js.css";
import { toDateString } from '../../pages/cameraHelpers';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import download from 'downloadjs';

import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";



export default function CameraViewer(props){

	const { routes } = useDataContext();

	const playerRef = useRef();
	const canvasRef = useRef();
	const wrapperRef = useRef();
	const snapshotRef = useRef();
	const dateTimeRef = useRef(new Date(1999, 1, 1)); // set arbitrary impossible date
	const [player, setPlayer] = useState();
	const [zoom, setZoom] = useState(1);

	const mobileCheck = () =>  {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		console.log("mobile check", check);
		return check;
	};

	// On Load setup player
	useEffect(() => {
		// Create the videojs object
		const p = videojs(
			playerRef.current,
			{
				autoplay: false, 
				muted: mobileCheck() ? false : true, 
				// fill:true,
				// fluid:true,
				// html5:{overrideNative: true},
				html5: {hls: {overrideNative: false}},
				// fluid: true,
				// aspectRatio: '9:16'
			}
		);
		// p.width(800);

		// p.src("http://localhost:5000/video/playlist")
		// p.src({
		// 		src: "http://localhost:5000/video/playlist?date=2021-07-13T10:30&location=10&camera=output",
		// 		// src: "http://34.121.132.186/live1.m3u8",
		// 		type: "application/x-mpegURL",
		// });

		// Deal wtih non-existtant video file skippinng
		p.tech_.on("retryplaylist", () => {
			console.log("Problem with", props.camera);
			p.currentTime(p.currentTime() + 17);
		});

		// On exiting full screen make sure we track that
		p.on("fullscreenchange", (e) => {
			if (!p.isFullscreen()){
				props.setFullScreen();
			}
		});

		p.on("play", (e) => {
			console.log("Play event");
			props.setIsPlaying(true);
		})

		p.on("pause", (e) => {
			console.log("Pause event");
			props.setIsPlaying(false);
		})

		// p.on("seeking", (e) => {
		// 	console.log("Seeking event", e);
		// })

		// p.on("seeked", (e) => {
		// 	console.log("Seeked event--has jumped to new time", e);
		// 	console.log("New current time", p.currentTime());
		// })

		p.on("loadedmetadata", (e) => {
			console.log("Loaded event");
			// console.log(e);
			// setTimeout(resize, 1000);
			// setTimeout(() => {console.log("Where I would resize")}, 1000)
			// setTimeout(() => {
			console.log("About to resize");
			let w = wrapperRef.current.clientWidth;
			p.width(w);
			// }, 500);
		})

		p.on('error', (e) => {
			console.log("got a Video.js error");
			console.warn(e);
		})

		// p.on('sourceset', (e) => {
		// 	console.log("Source SEt");
		// })

		// Set player state
		setPlayer(p);

		let _resize = () => {
			console.log("_resize");
			if (p){
				let w = wrapperRef.current.clientWidth;
				p.width(w);
			}
		}
		window.addEventListener('resize', _resize);

		// Cleanup
		return () => {
			if (player){
				player.dispose();
			}
			window.removeEventListener('resize', _resize);
		}
	}, []);

	// setup resize listener
	// let timeoutID = null;
	// let evtFnc = () => {
	// 	clearTimeout(timeoutID);
	// 	timeoutID = setTimeout(() => {
	// 		resize();
	// 	}, 150)
	// }
	

	// On Change of date to update source
	useEffect(() => {
		if ( (props.videoDateTime != undefined) & (player != undefined) ){
			console.log("In datetime useEffect");
			// If date is different update source
			let prevSplit = toDateString(dateTimeRef.current).split('T');
			let newSplit = toDateString(props.videoDateTime).split('T')
			let prevDate = prevSplit[0];
			let newDate = newSplit[0];
			if (prevDate != newDate){
				updateVideoSource();
			}

			// if Time is different move video to new time
			let newTime = newSplit[1];
			let prevTime = prevSplit[1];
			// if ( (newTime != prevTime) | (prevDate != newDate)){
			// 	let hour = parseInt(newTime.split(":")[0]);
			// 	let minute = parseInt(newTime.split(":")[1]);
			// 	jumpTo(hour, minute);
			// }

			let hour = parseInt(newTime.split(":")[0]);
			let minute = parseInt(newTime.split(":")[1]);
			console.log("New Time", newTime);
			jumpTo(hour, minute);

			// Update refs
			dateTimeRef.current = props.videoDateTime;
		}
	}, [props.videoDateTime, player]);

	/**
	 * Play or pause the video based on isPlaying prop
	 */
	useEffect(() => {
		if (mobileCheck()){return}
		if (player){
			if (props.isPlaying){
				player.play();
			}
			else{
				player.pause();
			}
		}
	}, [props.isPlaying])

	/**
	 * Fast forward and rewind hooks to move the video forward or back
	 */
	useEffect(() => {
		if (player){
			if (props.currentLocation.id == 2){
				// for real ones do a real 10 minute jump
				console.log("Crenshaw hack FF");
				player.currentTime(player.currentTime() + 300);
				return;
			}
			player.currentTime(player.currentTime() + 100);
		}
	}, [props.fastForwardCount])

	useEffect(() => {
		if (player){
			if (props.currentLocation.id == 2){
				console.log("Crenshaw Hack Rewind");
				player.currentTime(player.currentTime() - 300);
				return;
			}
			player.currentTime(player.currentTime() - 100);
		}
	}, [props.rewindCount])


	/**
	 * Playback speed update
	 */
	useEffect(() => {
		if (player){
			player.playbackRate(props.speed);
			player.defaultPlaybackRate(props.speed);
		}
	}, [props.speed])

	/**
	 * Show full screen if this one is selected
	 */
	useEffect(() => {
		if (player){
			if (props.fullScreen == props.camera){
				player.requestFullscreen();
			}
		}
	}, [props.fullScreen])

	useEffect(() => {
		if (player){
			if (props.isLive){
				if (props.currentLocation.id == 2){
					// if is crenshaw (hack for now)
					console.log("Crenshaw Live Hack");
					player.src({
						// src: `http://34.121.132.186/live${props.camera}.m3u8`,
						src: `https://live.hellometer.io/live${props.camera}.m3u8`,
						type: "application/x-mpegURL"
					});
					player.playbackRate(1);
					player.defaultPlaybackRate(1);
				}
			}
			else{
				// Not live, so go back to normal feed
				console.log("Go back to normal feed");
				updateVideoSource();

				// Go to right time in the video
				let dt = toDateString(props.videoDateTime).split('T');
				let time = dt[1]
				let hour = parseInt(time.split(":")[0]);
				let minute = parseInt(time.split(":")[1]);
				jumpTo(hour, minute);
			}

			if (!mobileCheck()){
				player.play();
			}
			
		}
	}, [props.isLive])

	// Resize the cameras if the grid option is changed
	useEffect(() => {
		console.log("Grid triggered camera resize");
		resize()
	}, [props.grid])


	const updateVideoSource = () => {
		// return;
		console.log("Updaing video srouce");
		let base = routes['playlist'];

		// get time in UTC if crenshaw
		let datetime = props.videoDateTime;
		console.log("Prop datetime", datetime);
		// if (props.currentLocation.id == 2){
		// 	// crenshaw
		// 	console.log("Crenshaw Date Hack");
		// 	datetime = new Date(datetime.getTime() + datetime.getTimezoneOffset() * 60000);
		// }
		// console.log("Adjusted datetime", datetime);
		let rand = Math.floor(Math.random()*1000);
		// let newSrc = `${base}?location=${props.currentLocation.id}&date=${toDateString(datetime)}&camera=${props.camera}&timezone=${props.currentLocation.time_zone}&rand=${rand}`
		let newSrc = `${base}?location=${props.currentLocation.id}&date=${toDateString(datetime)}&camera=${props.camera}&timezone=${props.currentLocation.time_zone}&legacy=true`
		player.src({
				src: newSrc,
				type: "application/x-mpegURL",
		});

		if (mobileCheck()){return}
		player.play();
		player.playbackRate(props.speed);
		player.defaultPlaybackRate(props.speed);
	}

	const jumpTo = (hour, minute) => {
		console.log("Jump To", hour, minute);
		let approxTime = (hour + (minute/60)) * 1000;
		approxTime = hour*60*60 + minute*60;
		// if (props.currentLocation.id == 2){
		// 	// Crenshaw has different video lengths
		// 	console.log("Jumping in Crenshaw");
		// 	approxTime = hour*60*60 + minute*60 - 60; // -120 is just a small tweaks
		// }
		player.currentTime(approxTime);
		// props.setIsPlaying(true); // <--- fix bug where when paused and switch source, video plays but icon doesn't
		if (mobileCheck()){return}
		player.play();
	}


	const snapshot = () => {
		// set the canvas dimensions
		canvasRef.current.width = playerRef.current.videoWidth;
		canvasRef.current.height = playerRef.current.videoHeight;
		canvasRef.current.getContext('2d').drawImage(playerRef.current, 0, 0, 
					playerRef.current.videoWidth, playerRef.current.videoHeight);
		canvasRef.current.toBlob( (blob) => {
			download(blob, 'snapshot.jpg', 'img/jpeg');
		} );

	}

	const makeFluid = () => {
		if (player){
			player.fill(true);
		}
	}

	const cancelFluid = () => {
		if (player){
			player.fill(false);
		}
	}

	const resize = () => {
		if (player){
			let w = wrapperRef.current.clientWidth;
			player.width(w);
		}
	}

	

	return(
		<>
			{/* <button className='btn bg-blue-600 text-white' onClick={makeFluid}>Fill</button>
			<button className='btn bg-red-600 text-white' onClick={cancelFluid}>Cancel</button> */}
			{/* <button className='btn bg-green-400' onClick={resize}>Resize</button> */}
			<div className='flow-root'>
				<h3 className='m-3 float-left'>Camera: {props.camera}</h3>
				<div className={`float-right pr-3 pt-3 ${mobileCheck() ? 'hidden' : ''}`}>
					<IconButton onClick={snapshot}  ref={snapshotRef} size='small'>
						<CameraAltIcon className='cameraIcon'/>
					</IconButton>
				</div>
			</div>
			{/* <div data-vjs-player ref={wrapperRef} style={{'borderRadius':'10px', 'overflow':'hidden', 'margin':'1.5em', 'position':'relative'}}> */}
			<div data-vjs-player ref={wrapperRef} className='overflow-hidden rounded-b-lg'>
				<TransformWrapper>
					<TransformComponent>
						<video
							controls // <--------------- we want to get rid of these when dev is donen
							muted
							ref={playerRef}
							className="video-js"
							// style={{'width':'100%', 'height':'100%'}}
							// style={{'position':'absolute'}}
							// style={{'transform': `scale(${zoom})`}}
							>
						</video>
					</TransformComponent>
				</TransformWrapper>
				{/* <IconButton onClick={snapshot}  ref={snapshotRef} style={{'position':'absolute', 'top':'0px', 'left':'0px'}}> */}
				{/* <IconButton onClick={snapshot}  ref={snapshotRef}>
					<CameraAltIcon className='cameraIcon' style={{color:'red'}}/>
				</IconButton> */}
				{/* <span style={{'color':'white', 'position':'absolute', 'top':'30px', 'left':'400px', 'fontWeight':'bold'}}>
					Camera: {props.camera}
				</span> */}
			</div>
			<canvas id="canvas" style={{"overflow":"auto", 'display':'none'}} ref={canvasRef}></canvas>
			

		</>
	)
}